module.exports = __webpack_public_path__ + "img/sports.bad8f234.png";